/* eslint-disable camelcase */
import MediaType from "nexia_mobile/framework/media_type";

const oneDayAgo = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();

const thermostat = {
  type: "thermostat",
  id: 11,
  name: "Thermostat",
  current_fan_mode: 0,
  current_mode: 3,
  current_run_mode: 0,
  delta: 3,
  features: [
    {
      name: "thermostat",
      temperature: 77,
      status: "System Idle",
      actions: {
        set_heat_setpoint: {
          method: "POST",
          href: "thermostat/11/setpoints",
        },
        set_cool_setpoint: {
          method: "POST",
          href: "thermostat/11/setpoints",
        },
      },
      setpoint_delta: 3,
      setpoint_increment: 1,
      setpoint_heat_min: 55,
      setpoint_heat_max: 95,
      setpoint_cool_min: 60,
      setpoint_cool_max: 100,
      setpoint_heat: 70,
      setpoint_cool: 80,
    },
  ],
  icon: { name: "thermostat", modifiers: ["temperature-77"] },
  operating_state: "System Idle",
  scale: "F",
  setpoints: { heat: 70, cool: 80 },
  settings: [
    {
      current_value: 3,
      labels: ["Off", "Heat", "Cool", "Auto"],
      title: "Mode",
      type: "mode",
      values: [0, 1, 2, 3],
    },
  ],
  supported_fan_modes: { 0: "Auto", 1: "On" },
  supported_modes: { 0: "Off", 1: "Heat", 2: "Cool", 3: "Auto" },
  supported_run_modes: { 0: "Hold Temp", 2: "Energy Save" },
  temperature: 77,
  value: 255,
};

const livingRoomLights = {
  name: "Living Room Lights",
  id: 12,
  type: "switch",
  value: 45,
  icon: { name: "switch_on" },
  settings: [],
};

const frontDoorLock = {
  name: "Front Door Lock",
  id: 13,
  battery_level: 66,
  current_action: "unlock",
  current_state: "locked",
  has_temporary_code: false,
  icon: { name: "lock_locked", modifiers: [] },
  supports_user_codes: false,
  type: "lock",
  user_code_length: 4,
  value: 255,
  status: "Locked",
  features: [
    {
      name: "lock_lock",
      is_locked: true,
      actions: {
        lock: {
          method: "POST",
          href: "locks/13/lock",
        },
      },
    },
    {
      name: "unlock_lock",
      is_unlocked: false,
      actions: {
        lock: {
          method: "POST",
          href: "locks/13/unlock",
        },
      },
    },
  ],
};

const motionSensor = {
  name: "Hallway Motion Sensor",
  id: 14,
  current_state_text: "no motion detected",
  icon: { name: "sensor_motion_idle", modifiers: [] },
  sensor_type: "motion",
  settings: [],
  type: "sensor",
  value: 0,
  features: [
    {
      name: "battery",
      label: "75% remaining",
      updated_at: oneDayAgo,
      icon: "battery_mostly_full",
    },
  ],
};

const masterBedroomLights = {
  name: "Master Bedroom Lights",
  id: 16,
  type: "switch",
  value: 45,
  icon: { name: "switch_on" },
  settings: [],
};

const masterBedroomLock = {
  name: "Master Bedroom Lock",
  id: 17,
  battery_level: 99,
  current_action: "unlock",
  current_state: "locked",
  has_temporary_code: false,
  icon: { name: "lock_locked", modifiers: [] },
  supports_user_codes: false,
  type: "lock",
  user_code_length: 4,
  value: 255,
};

const upstairsGroup = {
  name: "Upstairs",
  id: 15,
  type: "group",
  icon: [{ name: "switch_on" }, { name: "lock_locked" }],
  _links: {
    child: [{ data: masterBedroomLights }, { data: masterBedroomLock }],
  },
};

const addHistoryLink = (model, filterType) => {
  if (!model._links) {
    model._links = {};
  }
  model._links["nexia:history"] = {
    href: `/events?${filterType}_id=${model.id}`,
  };
};

const addEvents = (device, events) => {
  device._links["nexia:history"].data = {
    item_type: MediaType.EVENT,
    items: events,
  };
};

addHistoryLink(thermostat, "device");
addHistoryLink(livingRoomLights, "device");
addHistoryLink(frontDoorLock, "device");

addHistoryLink(motionSensor, "device");
addEvents(motionSensor, [
  {
    device_name: motionSensor.name,
    user_name: "",
    description: "Motion detected",
    occurred_at: oneDayAgo,
  },
  {
    device_name: motionSensor.name,
    user_name: "",
    description: "Battery Level: 75% remaining",
    occurred_at: oneDayAgo,
  },
]);

addHistoryLink(masterBedroomLights, "device");
addHistoryLink(masterBedroomLock, "device");

const devices = {
  item_type: MediaType.DEVICE,
  items: [
    thermostat,
    livingRoomLights,
    frontDoorLock,
    motionSensor,
    upstairsGroup,
  ],
};

const modes = {
  item_type: MediaType.MODE,
  items: [
    {
      id: 21,
      name: "Home",
      current_mode: false,
      icon: "home.png",
      settings: [],
    },
    {
      id: 22,
      name: "Away",
      current_mode: false,
      icon: "away.png",
      settings: [],
    },
    {
      id: 23,
      name: "Vacation",
      current_mode: true,
      icon: "picture.png",
      settings: [],
    },
  ],
};

const events = {
  item_type: MediaType.EVENT,
  _links: {
    page: {
      data: {
        current_page: 1,
        page_count: 1,
      },
    },
  },
};

const videos = {
  item_type: MediaType.VIDEO,
  items: [
    {
      id: 1,
      name: "test",
      size: "size",
      write_protected: false,
      thumbnail: "attrs.thumbnail",
      created_at: "created_at",
    },
  ],
};

const automations = {
  item_type: MediaType.AUTOMATION,
  items: [
    {
      id: 31,
      name: "Movie Night",
      settings: [],
      triggers: [],
      description:
        "On Saturdays at sunset Living Room Lights will be set to 50% AND Send an alert",
      enabled: true,
      icon: [
        { name: "calendar_empty", modifiers: [] },
        { name: "dimmer_30", modifiers: [] },
        { name: "message", modifiers: [] },
      ],
    },
  ],
  _links: {
    self: { href: "automations" },
  },
};

addHistoryLink(automations.items[0], "automation");

const location = {
  id: 1,
  name: "Demo House",
  _urlMap: {},
  _links: {},
};

location._links.child = [
  { data: modes, type: MediaType.COLLECTION },
  { data: devices, type: MediaType.COLLECTION },
  { data: automations, type: MediaType.COLLECTION },
  { data: events, type: MediaType.COLLECTION },
  { data: videos, type: MediaType.COLLECTION },
];

function addSelfLink(resource, objectType) {
  let url = objectType || resource.type || "resource";
  if (resource.id != null) {
    url += `/${resource.id}`;
  }
  location._urlMap[url] = resource;
  if (resource._links == null) {
    resource._links = {};
  }
  resource._links.self = { href: url };
}

addSelfLink(automations, "automations");
addSelfLink(videos, "videos");
addSelfLink(events, "events");

_.each(automations.items, (mode) => addSelfLink(mode, "automation"));

_.each(modes.items, (mode) => addSelfLink(mode, "mode"));

_.each(devices.items, (device) => {
  addSelfLink(device);

  _.each(device.settings, (setting) =>
    addSelfLink(setting, `${device._links.self.href}/${setting.type}`)
  );

  _.each(device._links.child, (link) => {
    if (link.data != null) {
      addSelfLink(link.data);
    }
  });
});

export default location;



// WEBPACK FOOTER //
// ./src/models/fixtures/location.js